/* src/app/pages/doc-upload/doc-upload.component.scss */
.upload button {
  margin-left: 5px;
}
.section-title {
  margin-bottom: 50px;
}
.file-input-btn {
  margin-bottom: 0;
}
.upload .previews {
  margin: 0 10px;
}
.upload .localsubmit {
  margin: 0 10px;
}
.example-headers-align .mat-expansion-panel-header-title,
.example-headers-align .mat-expansion-panel-header-description {
  flex-basis: 0;
}
.example-headers-align .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}
mat-form-field {
  margin-right: 12px;
}
.btn {
  margin-right: 8px;
}
.mat-action-row {
  border-top-style: none;
  padding: 4px 4px 4px 4px;
}
.rt-full-width {
  width: 70%;
}
ol {
  columns: 1;
  -webkit-columns: 1;
  -moz-columns: 1;
}
li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}
.fileupload-drop-zone {
  border: 1px solid green;
  height: 50px;
}
.divLabel {
  float: left;
  border-radius: 10%;
  height: 32px;
  color: white;
}
/*# sourceMappingURL=doc-upload.component.css.map */
